import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const teamImporterSelectors = importerSelectors(
  'team.importer',
);

export default teamImporterSelectors;
